import { BaseApi } from "./baseService";
import { Http, RequestOptions } from "@angular/http";
import { ConfigService } from "./configService";
import { Injectable } from "@angular/core";
import { BaseResponse } from "../objects/common/baseResponse";
import { ManufacturerGetResponse } from "../objects/apps/manufacturerGetResponse";

@Injectable()
export class SipService extends BaseApi {

    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public getManufacturers(request: any): Promise<BaseResponse<ManufacturerGetResponse>> {
        return this.post(new RequestOptions({
            url: `v2/manufacturers/search`,
            body: request
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/sipService.ts